import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getProDocumentTitle } from "../../lib/document-title";

export function RouteDocumentTitle() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    document.title = getProDocumentTitle(pathname, search);
  }, [pathname, search]);

  return null;
}
